import Store from 'store/store';

Store.on('PASSWORD_ACCEPTED', pageId => {
	const unlockedSections = Store.get().unlockSections || [];
	if (unlockedSections.indexOf(pageId) === -1) {
		unlockedSections.push(pageId);
	}

	Store.get().set({ unlockedSections: unlockedSections });
});